export const VISIBLE_ORDER_IMAGES_COUNT = 3
export const VISIBLE_ORDER_IMAGES_COUNT_TINY = 2
export const VISIBLE_ORDERS_COUNT = 5

// should always be multiple of VISIBLE_ORDERS_COUNT
export const PREFETCH_ORDERS_AMOUNT = 20
export const DOCUMENT_TYPES = {
  INVOICE: 'invoice',
  USAGE_NOTICE: 'custinformation',
  VOUCHER: 'creditnote'
}
